<!--
    ShowFooter.vue
    Component to show default footer elements, including copyright, disclaimer, and terms links.
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
    <div class="footer">
        <p>Copyright © {{ new Date().getFullYear() }} Triumphant Heart International, Inc. All rights reserved.</p>

        <p>
            <a href="https://www.thedissertationmentor.com/pages/terms"  target="_blank">Terms of Use</a>
            |
            <a href="https://www.thedissertationmentor.com/pages/privacy" target="_blank">Privacy</a>
        </p>

        <div class="disclaimer">The Dissertation Mentor® and The Dissertation Warrior® are registered trademarks of Triumphant Heart International, Inc.</div>

    </div>
</template>

<script>
export default {
    name: '',
    data: function() {
        return {};
    }
};
</script>

<style scoped>
</style>
